import { NgTemplateOutlet, UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, contentChild, inject, input, TemplateRef } from '@angular/core';
import { ProductAddToBasketComponentDef } from '@df/catalog-ui/product/add-to-basket/product-add-to-basket.component.def';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { ProductResource } from '@df/catalog/product/product.resource';
import { Client } from '@df/core/service/client';
import { Status } from '@df/core/status';
import { ImageModule } from '@df/module-image/image.module';
import type { BasketItem } from '@df/session/api/basket/basket-item';
import { IResponseRemoveFromBasket } from '@df/session/api/basket/basket.service';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { LocalBasket } from '../../../basket/basket.decorator';
import { ActionComponent } from '../../../ui/api/action.component';
import { ResultComponent } from '../../../ui/api/result.component';
import { ShellComponent } from '../../../ui/display/local-shell.component';

@Component({
    selector: 'protection-plans-item',
    templateUrl: 'protection-plans-item.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        ActionComponent,
        ICmsClientModule,
        ImageModule,
        NgTemplateOutlet,
        ResultComponent,
        ShellComponent,
        SizeClassDirective,
        TranslationModule,
        UpperCasePipe
    ]
})
export class ProtectionPlansItemComponent extends ProductAddToBasketComponentDef {
    readonly item = input<BasketItem>();

    override product?: Product<IProductDataV3>;
    private readonly productResource = inject(ProductResource);
    protected readonly client = inject(Client);

    readonly protectionPlansCheckbox = contentChild<TemplateRef<any>>('protectionPlansCheckbox');

    protected readonly removeStatus = new Status();

    get currencySymbol(): string | undefined {
        const base = this.app.data.currency.base;

        const currency = this.app.data.currency.list.find(curr => curr.code === base);
        if (currency) {
            return currency.symbol;
        }
        return undefined;
    }

    get coveredProducts(): Product<IProductDataV3>[] {
        if (!this.product) return [];

        const basket = this.app.customer.basket as LocalBasket;
        const productIds = basket.getProductsForPlan(this.product.id);

        if (productIds.length === 0) return [];

        return this.productResource.getAllExisting(productIds) as Product<IProductDataV3>[];
    }

    /**
     * Removes item from basket
     * @return {promise}
     */
    remove(): Promise<IResponseRemoveFromBasket> {
        return this.item()!.remove(this.removeStatus);
    }
}
